export const LICENSING_STATUS = {
  needs_changes: 'Needs Changes',
  will_require_approval: 'Will Require Approval',
  approval_required: 'Approval Required',
  marks_in_review: 'Marks In Review',
  design_duplicate: 'Design Duplicate',
  marks_pre_approved: 'Marks Pre-Approved',
  marks_approved: 'Marks Approved',
  no_marks: 'No Marks',
};

export const LICENSING_STATUS_PRIORITY = {
  needs_changes: 8,
  will_require_approval: 7,
  approval_required: 6,
  marks_in_review: 5,
  design_duplicate: 4,
  marks_pre_approved: 3,
  marks_approved: 2,
  no_marks: 1,
};

export const LICENSING_STATUS_CLASS = {
  needs_changes: 'needs-changes',
  will_require_approval: 'will-require-approval',
  approval_required: 'approval-required',
  marks_in_review: 'marks-in-review',
  design_duplicate: 'design-duplicate',
  marks_pre_approved: 'marks-pre-approved',
  marks_approved: 'marks-approved',
  no_marks: 'no-marks',
};

export const LICENSING_STATUS_PILL_STYLES = {
  needs_changes: {
    background: '#FFF4F4 0% 0% no-repeat padding-box',
    borderColor: '#FFB1B1',
    color: '#E86868',
    borderBottom: '0.8px dashed #FFB1B1',
    borderRight: '0.8px dashed #FFB1B1',
  },
  will_require_approval: {
    background: '#F5F6FA 0% 0% no-repeat padding-box',
    borderColor: '#AFB2C9',
    color: '#474B6D',
    borderBottom: '0.8px dashed #AFB2C9',
    borderRight: '0.8px dashed #AFB2C9',
  },
  approval_required: {
    background: '#FFF8FD 0% 0% no-repeat padding-box',
    borderColor: '#F0C1E0',
    color: '#EB79C5',
    borderBottom: '0.8px dashed #F0C1E0',
    borderRight: '0.8px dashed #F0C1E0',
  },
  licensing_review: {
    background: '#FEF9F6 0% 0% no-repeat padding-box',
    borderColor: '#FAC598',
    color: '#F49B50',
    borderBottom: '0.8px dashed #FAC598',
    borderRight: '0.8px dashed #FAC598',
  },
  pre_approved: {
    background: '#F6FBFF 0% 0% no-repeat padding-box',
    borderColor: '#71A9DE',
    color: '#4A8BC7',
    borderBottom: '0.8px dashed #71A9DE',
    borderRight: '0.8px dashed #71A9DE',
  },
  approved: {
    background: '#F4FFEA 0% 0% no-repeat padding-box',
    borderColor: '#8AD34C',
    color: '#8AD34C',
    borderBottom: '0.8px dashed #8AD34C',
    borderRight: '0.8px dashed #8AD34C',
  },
};

export const LICENSING_LABEL_DISABLE_STORE = [
  // 'Approval Required',
  // 'Marks In Review',
  // 'Will Require Approval',
  // 'Licensing Review',
  'Needs Changes',
  'needs_changes',
];

export const LICENSING_LABEL_DISABLE_CART = ['Needs Changes', 'needs_changes'];

export const LICENSING_STATUS_FILTER_PROOFCARDS = [
  'needs_changes',
  'will_require_approval',
  'approval_required',
  'marks_in_review',
  'licensing_review',
];
